<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-baoming"></i>
      考试详情
    </div>
    <div class="padding-sm">
      <el-form :model="examForm"  ref="examForm" label-width="120px">
        <el-form-item label="科目" prop="subject_first">
          <el-input readonly v-model="examForm.subject_first"></el-input>
        </el-form-item>
        <el-form-item label="考试名称" prop="name">
          <el-input readonly v-model="examForm.name" placeholder="请输入考试名称"></el-input>
        </el-form-item>
        <el-form-item label="考试费用" prop="fee">
          <el-input type="number" readonly v-model.number="examForm.fee" placeholder="请输入考试费用"></el-input>
        </el-form-item>
        <el-form-item label="考试时间" prop="time">
          <el-date-picker
              style="width: 100%"
              readonly
              v-model="examForm.time"
              :picker-options="pickerOptions"
              type="daterange"
              range-separator="至"
              start-placeholder="请选择考试开始日期"
              end-placeholder="请选择考试结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报名截止时间" prop="enroll_end_time">
          <el-date-picker
              style="width: 100%"
              readonly
              v-model="examForm.enroll_end_time"
              :picker-options="pickerOptions"
              type="date"
              placeholder="请选择报名截止时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="考试详情" prop="content">
          <div v-html="examForm.content" ></div>
        </el-form-item>
      </el-form>

    </div>

  </div>
</template>

<script>
import {getExam} from "@/api/fuse";


export default {
  name: "examDetail",
  data() {
    return {
      id: '',
      subjects: [],
      signList: [],
      examForm: {
        subject_first: '',
        name: '',
        fee: '',
        time: null,

        enroll_end_time: null,
        content: '',
        student_enroll_id: ''
      },

      pickerOptions: {
        disabledDate(time) {
          console.log(time)
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

    };
  },

  created() {
    this.$emit(
        "setIndex",
        '/fuse/exam',
        "当前位置：考试管理 > 考试详情",
        true
    );
    this.id = this.$route.query.id
   this.getDetail();
  },

  methods: {

    async getDetail() {
      let _data = await getExam(this.id)
      this.examForm = {
        name:_data.data.name,
        subject_first:_data.data.subject_name,
        time:[new Date(_data.data.exam_start_time*1000),new Date(_data.data.exam_end_time*1000)],
        fee:_data.data.fee,
        enroll_end_time:new Date(_data.data.enroll_end_time),
        content:_data.data.content,
        student_enroll_id:_data.data.student_enroll_id,
      }
    },

  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.table-item {
  p {
    span {
      color: #e4396c;
    }
  }

  input {
    display: block;
    height: 40px;
    padding: 0 10px;
    border: 1px solid #eee;
    margin-left: 10px;
  }

  input.radio {
    margin: 0;
  }

  textarea {
    display: block;
    border: 1px solid #eee;
    height: 60px;
    padding: 0 10px;
    margin-left: 10px;
  }
}
</style>